import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  form {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  /* Title and fields from the top, as on the mock; the button keeps the bottom right corner. */
  section {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;

    & h3 {
      margin: 0 0 30px;
      font-size: 20px;
      font-weight: bold;
      color: ${ ({ theme }) => theme.colors.primary };
    }

    .info-note {
      margin: 8px 0 0;
    }
  }

  .saveButton {
    width: max-content;
    padding: 20px;
    align-self: flex-end;
    margin-top: 24px;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
